export const sculptureEditionSubmitOmitKeys = [
  "id",
  "instanceId",
  "masterArtworkId",
  "history",
  "mouvements",
  "collector",
  "updatedBy",
  "updatedById",
  "createdBy",
  "createdById",
  "updatedAt",
  "createdAt",
  "attachments",
] as const;

export const getSculptureEditionTabs = (
  t: (key: string) => string,
  options?: { provenanceMode?: boolean },
) => [
  { value: "informations", label: t("sculpture.tabs.informations") },
  { value: "dimensions", label: t("sculpture.tabs.dimensions") },
  {
    value: "historique",
    label: options?.provenanceMode
      ? t("sculpture.tabs.provenance")
      : t("sculpture.tabs.historique"),
  },
  { value: "links", label: t("sculpture.tabs.links") },
  { value: "technicalNotes", label: t("sculpture.tabs.technicalNotes") },
  { value: "conditionReport", label: t("sculpture.tabs.conditionReport") },
  { value: "certificat", label: t("sculpture.tabs.certificat") },
  { value: "mouvement", label: t("sculpture.tabs.mouvement") },
];
